import Service from "../Service";
//import PatientService from "./PatientService";
import UserService from "./UserService";
const service = new Service();
const customerType = 'Health Professional';
export default class PhysicianService{
    static Search(term){     
        
        return service.request('ReferringPhysicians', {
            get:{
                term:term
            }
        });   

        /*return UserService.Search(term).then((json) => {
            return json.filter(client => client.customerType === customerType);
        })*/
    }

    static Save(user){        
        user.customerType = customerType;
        console.log('Physician Save Initiayed!:', user)
        return UserService.Save(user);
    }

    static GetById = UserService.GetById;
}


// WEBPACK FOOTER //
// ./src/api/services/PhysicianService.js